export function formatHour(hour) {
  return hour < 10 ? `0${hour}` : hour
}
